/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeSecretsDeleteComputeSecret } from "../../funcs/computeSecretsDeleteComputeSecret.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteComputeSecretRequest$inboundSchema,
};

export const tool$computeSecretsDeleteComputeSecret: ToolDefinition<
  typeof args
> = {
  name: "compute-secrets-delete-compute-secret",
  description: `Delete a secret`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeSecretsDeleteComputeSecret(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
